/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
import { useEffect, useState } from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Avatar,
  Box,
  Button,
  Divider,
  Drawer,
  Hidden,
  List,
  Typography
} from '@mui/material';
import useAuth from 'src/context/AuthContext';
import ROUTE, { getAppRoutes } from 'src/utils/routeConstants';
import { USER_ROLES } from 'src/utils/constants';
import { useDispatch } from 'react-redux';
import { getApprovalsCount } from 'src/redux/cardApprovalSlice';
import { getUserRole, isAdminUser } from 'src/utils/getInitials';
import NavItem from './NavItem';
import { LogoutModal } from './DashboardNavbar';

const DashboardSidebar = ({ onMobileClose, openMobile }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { getUser } = useAuth();
  const user = getUser();
  const isAdmin = isAdminUser(getUser);
  const isApprover = user?.role === USER_ROLES.approver;

  const [showAlert, setShowAlert] = useState(false);

  const handleAlertClose = () => setShowAlert(false);

  const appRoutes = getAppRoutes(user);

  const openLogoutModal = () => setShowAlert(true);

  useEffect(() => {
    if ((isAdmin || isApprover) && !!location.state?.fromDashboard) {
      dispatch(getApprovalsCount());
    }
    if (openMobile && onMobileClose) {
      onMobileClose();
    }
  }, [location.pathname]);

  const content = (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%'
      }}
    >
      <Box
        sx={{
          alignItems: 'center',
          display: 'flex',
          flexDirection: 'column',
          p: 2
        }}
      >
        {user && (
          <>
            <Avatar
              component={RouterLink}
              sx={{
                cursor: 'pointer',
                width: 64,
                height: 64,
                bgcolor: 'gray',
                mb: 1
              }}
              to={ROUTE.account}
            />
            <Typography color="textPrimary" variant="h5">
              {`${user.first_name} ${user.last_name}`}
            </Typography>
            <Typography color="textSecondary" variant="body2">
              {getUserRole(user.role)}
            </Typography>
            <Hidden lgUp>
              <Button onClick={openLogoutModal} autoFocus sx={{ mt: 2 }}>
                Logout
              </Button>
            </Hidden>
          </>
        )}
      </Box>
      <Divider />
      <LogoutModal open={showAlert} onClose={handleAlertClose} />
      <Box sx={{ p: 2 }}>
        <List>
          {appRoutes.map((item) => <NavItem key={item.title} item={item} />)}
        </List>
      </Box>
      <Box sx={{ flexGrow: 1 }} />
    </Box>
  );

  return (
    <>
      <Hidden lgUp>
        <Drawer
          anchor="left"
          onClose={onMobileClose}
          open={openMobile}
          variant="temporary"
          PaperProps={{
            sx: {
              width: 256
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
      <Hidden lgDown>
        <Drawer
          anchor="left"
          open
          variant="persistent"
          PaperProps={{
            sx: {
              width: 256,
              top: 64,
              height: 'calc(100% - 64px)'
            }
          }}
        >
          {content}
        </Drawer>
      </Hidden>
    </>
  );
};

DashboardSidebar.propTypes = {
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool
};

DashboardSidebar.defaultProps = {
  onMobileClose: () => {},
  openMobile: false
};

export default DashboardSidebar;
